import uriTemplate from 'uri-template';
import api from '../../../../shared/api.json';

import * as TYPES from '../../../constants/actionTypes';
import * as TRACKING_TYPES from '../../../actions/analyticsActions';

export function addAmbassador(profileId, image, data) {
    const url = uriTemplate.parse(api.profiles.ambassadors.index).expand({
        profileId,
    });

    return {
        types: [
            TYPES.ADD_AMBASSADOR,
            TYPES.ADD_AMBASSADOR_SUCCESS,
            TYPES.ADD_AMBASSADOR_FAIL,
        ],
        promise: (client) =>
            client.post(url, {
                data,
                fileUpload: { file: image, name: image.name, fields: data },
            }),
    };
}

export function deleteAmbassador(profileId, ambassadorId) {
    const url = uriTemplate.parse(api.profiles.ambassadors.delete).expand({
        profileId,
        ambassadorId,
    });

    return {
        types: [
            TYPES.DELETE_AMBASSADOR,
            TYPES.DELETE_AMBASSADOR_SUCCESS,
            TYPES.DELETE_AMBASSADOR_FAIL,
        ],
        promise: (client) => client.del(url),
        ambassadorId,
    };
}

export function editAmbassador(profileId, ambassadorId, data) {
    const url = uriTemplate.parse(api.profiles.ambassadors.update).expand({
        profileId,
        ambassadorId,
    });

    return {
        types: [
            TYPES.EDIT_AMBASSADOR,
            TYPES.EDIT_AMBASSADOR_SUCCESS,
            TYPES.ADD_AMBASSADOR_FAIL,
        ],
        promise: (client) => client.put(url, { data }),
        ambassadorId,
    };
}

export function updateImage(profileId, ambassadorId, image) {
    const url = uriTemplate.parse(api.profiles.ambassadors.updateImage).expand({
        profileId,
        ambassadorId,
    });

    return {
        types: [
            TYPES.UPDATE_AMBASSADOR_IMAGE,
            TYPES.UPDATE_AMBASSADOR_IMAGE_SUCCESS,
            TYPES.UPDATE_AMBASSADOR_IMAGE_FAIL,
        ],
        promise: (client) =>
            client.put(url, { fileUpload: { file: image, name: image.name } }),
        ambassadorId,
    };
}

export function expandAmbassador() {
    return {
        type: [TRACKING_TYPES.EXPAND_AMBASSADORS],
    };
}
